import { resourceState, resourceMutations } from '@/store/utils/resource';
import { ACCOUNT_RELATIONS } from '@/store/entities/schema_types';
import { accountAccountRelationsClient as client } from '@/api/clients';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  actions: {
    async load(ctx, { id, params = {} }) {
      try {
        const response = await client.list(id, { params });

        const { data, meta, links } = response.data;

        const clientIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACCOUNT_RELATIONS, data },
          { root: true }
        );

        ctx.commit('setIds', clientIds);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve({ clientIds });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
  },

  getters: {
    accountRelations: ({ ids }, getters, { entities }) =>
      ids.map((id) => entities.accountRelations.byId[id]),
  },
};
